import { createAction } from '@reduxjs/toolkit';
import { requestInvoice } from 'services/billingPortalService';
import billingPortalServiceErrors from 'services/billingPortalService/errors';

export const invoiceCleanSuccess = createAction(
  'INVOICES_INVOICE_CLEAN_SUCCESS'
);
export const invoiceRequestInit = createAction('INVOICES_INVOICE_REQUEST_INIT');
export const invoiceRequestSuccess = createAction(
  'INVOICES_INVOICE_REQUEST_SUCCESS'
);
export const invoiceRequestFail = createAction('INVOICES_INVOICE_REQUEST_FAIL');

export const invoiceClean = () => (dispatch) => dispatch(invoiceCleanSuccess());

const getErrorMessage = (errorMessage) => {
  switch (errorMessage) {
    case billingPortalServiceErrors.INVOICE_ALREADY_REQUESTED:
      return 'La factura de la compra ya fue solicitada.';
    case billingPortalServiceErrors.INVOICE_ALREADY_GENERATED:
      return 'La factura de la compra ya fue generada.';
    case billingPortalServiceErrors.UNAUTHORIZED:
      return 'No tiene permitido acceder a esta página.';
    default:
      if (errorMessage) {
        return errorMessage;
      }
      return 'Ocurrió un error inesperado, por favor inténtelo más tarde.';
  }
};

export const invoiceRequest = (requestBody) => async (dispatch) => {
  dispatch(invoiceRequestInit({}));
  try {
    const response = await requestInvoice(requestBody);
    if (response.statusCode === 200) {
      return dispatch(invoiceRequestSuccess());
    }
    return dispatch(
      invoiceRequestFail({
        error: {
          statusCode: response.statusCode,
          message: getErrorMessage(response.message),
        },
      })
    );
  } catch (error) {
    return dispatch(
      invoiceRequestFail({
        error: {
          statusCode: -1,
          message: error.message,
        },
      })
    );
  }
};
